import styled, { css } from 'styled-components/macro';

export const PdfRenderContainer = styled.div`
  position: relative;

  canvas {
    height: 100% !important;
  }
`;

export const Controll = styled.div<{ currentCanvasWidth: number }>`
  position: absolute;
  bottom: 16px;
  ${(props) =>
    props.currentCanvasWidth &&
    css`
      right: ${props.currentCanvasWidth / 2}px;
      transform: translateX(50%);
    `}

  p {
    color: #1f2939;
    margin: 10px 0;
  }

  button {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    padding: 0;

    &:disabled {
      cursor: not-allowed;
    }

    i {
      height: min-content;
      line-height: 7px;
      font-size: 16px;
    }

    &:first-child i {
      margin-right: 2px;
    }

    &:last-child i {
      margin-left: 2px;
    }
  }
`;

export const DocumentNavigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;
